// eslint-disable-next-line no-restricted-imports
import { Box, Button } from '@chakra-ui/react';
import { Rocket } from 'lucide-react';
import { forwardRef } from 'react';
import { useContactModal } from 'src/hooks/useContactModal';
import { ContactModal } from 'src/components/molecules/ContactModal';

export const StickyRibbon = forwardRef<HTMLDivElement>((_, ref) => {
  const { onOpen, modalProps } = useContactModal('signup');

  return (
    <>
      <Box ref={ref} position="fixed" bottom="16px" right="16px" zIndex="1000">
        <Button
          size="lg"
          variant="solid"
          bg="icon.green"
          color="white"
          _hover={{ bg: 'green.600' }}
          leftIcon={<Rocket size={20} />}
          onClick={onOpen}
          boxShadow="lg"
          borderRadius="8px"
          px={8}
          py={4}>
          Start Now
        </Button>
      </Box>
      <ContactModal {...modalProps} />
    </>
  );
});

StickyRibbon.displayName = 'StickyRibbon';
